import {
  deleteTaskThunk,
  fetchTodoTasks,
  updateTaskStatus,
} from "../../redux/Slices/todoSlice";
import { useDispatch } from "react-redux";
function TodoListItem({ item, coachId, handleEditTask }) {
  const dispatch = useDispatch();
  const deleteTask = (taskId) => {
    dispatch(deleteTaskThunk(taskId)).then(() => {
      dispatch(fetchTodoTasks(coachId));
    });
  };

  const handleCompleteTask = (item) => {
    const newTask = {
      coachId: coachId,
      taskId: item.taskId,
      status: !item.status,
    };
    dispatch(updateTaskStatus(newTask));
  };
  return (
    <div className="todo-task-item">
      <div
        className={`todo-task-tick ${item.status ? "selected" : "unselected"}`}
      >
        <div
          onClick={() => {
            handleCompleteTask(item);
          }}
          className="tick-circle"
        ></div>
      </div>
      <p className={`todo-task-name ${item.status ? "completed" : ""}`}>
        {item.task}
      </p>
      <i
        className="bi bi-pencil edit-icon cursor-pointer text-primary pr-3 fs-4"
        onClick={() => {
          handleEditTask(item);
        }}
      ></i>
      <i
        className="bi bi-trash delete-icon cursor-pointer text-colour-red pr-3 fs-4 mr-2"
        onClick={() => {
          deleteTask(item.taskId);
        }}
      ></i>
    </div>
  );
}

export default TodoListItem;
